export var AdamJSRoutes = {
    "/adam": {
        "name": "appLayout.harriSH.adam",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/tl-compliance-settings/tl-compliance-settings.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/adam/adam.module.js");
                }
            }
        ]
    },
};